module.exports = __webpack_public_path__ + "img/10.8f720cd2.jpg";